import { useNavigate } from 'react-router-dom';
import { useBlockNavigation } from './NavigationBlockerProvider';

const BlockableLink = ({ to, state, className, style, children, onClick, ...rest }) => {
  const navigate = useNavigate();
  const { getBlocker, showDialog } = useBlockNavigation();

  /**
   * handleClick
   * 
   * @summary Handles click events on the link, conditionally navigating or showing a blocking dialog.
   * 
   * @description
   * Prevents default link behavior and evaluates whether navigation should be blocked. If a blocker is active,
   * displays a confirmation dialog; otherwise, proceeds with navigation to the specified route.
   * 
   * @param {Event} e - The click event object.
   * 
   * @returns {void}
   * 
   * @example
   * <span onClick={handleClick}>Navigate</span>
   */
  const handleClick = (e) => {
    e.preventDefault();

    if (onClick) {
      onClick(e);
    }

    if (getBlocker()) {
      showDialog({ to, state });
    } else {
      navigate(to, { state });
    }
  };

  return (
    <span
      onClick={handleClick}
      className={className}
      style={{ cursor: 'pointer', ...style }}
      {...rest}
    >
      {children}
    </span>
  );
};

export default BlockableLink;
